import * as types from './meeting-boards.types';
import * as constants from './meeting-boards.constants';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import { IBoard, IBoardCreateForm } from '../../../resource/boards/board/board.types';
import { IBoardList, IBoardListCreateForm } from '../../../resource/boards/boardList/boardList.types';
import { DropResult } from 'react-beautiful-dnd';

export const storeMeetingBoards = (meetingBoards: types.IMeetingBoards): types.IStoreMeetingBoards => ({
  type: constants.STORE_MEETING_BOARDS,
  payload: meetingBoards,
});

export const clearMeetingBoards = (): types.IClearMeetingBoards => ({
  type: constants.CLEAR_MEETING_BOARDS,
});

export const getMeetingBoards = (meetingId: IMeetingSimple['id']): types.IGetMeetingBoards => ({
  type: constants.GET_MEETING_BOARDS,
  payload: meetingId,
});

/***BOARDS***/

export const createBoard = (board: IBoardCreateForm): types.ICreateBoard => ({
  type: constants.CREATE_BOARD,
  payload: board,
});

export const updateBoard = (boardId: IBoard['id'], board: IBoardCreateForm): types.IUpdateBoard => ({
  type: constants.UPDATE_BOARD,
  payload: {
    id: boardId,
    data: board,
  },
});

export const deleteBoard = (boardId: IBoard['id']): types.IDeleteBoard => ({
  type: constants.DELETE_BOARD,
  payload: boardId,
});

export const saveBoardOrder = (boardIds: IBoard['id'][]): types.ISaveBoardOrder => ({
  type: constants.SAVE_BOARD_ORDER,
  payload: {
    boardIds,
  },
});

export const dndBoard = (result: DropResult, meetingId: IMeetingSimple['id']): types.IDndBoard => ({
  type: constants.DND_BOARD,
  payload: {
    result,
    meetingId,
  },
});

/***BOARDLISTS***/

export const createBoardList = (boardList: IBoardListCreateForm): types.ICreateBoardList => ({
  type: constants.CREATE_BOARD_LIST,
  payload: boardList,
});

export const updateBoardList = (
  boardListId: IBoardList['id'],
  boardList: IBoardListCreateForm,
): types.IUpdateBoardList => ({
  type: constants.UPDATE_BOARD_LIST,
  payload: {
    id: boardListId,
    data: boardList,
  },
});

export const deleteBoardList = (boardListId: IBoardList['id']): types.IDeleteBoardList => ({
  type: constants.DELETE_BOARD_LIST,
  payload: boardListId,
});

export const moveBoardList = (result: DropResult): types.IMoveBoardList => ({
  type: constants.MOVE_BOARD_LIST,
  payload: result,
});

export const saveBoardListOrder = (listIds: IBoardList['id'][]): types.ISaveBoardListOrder => ({
  type: constants.SAVE_BOARD_LIST_ORDER,
  payload: {
    listIds,
  },
});

export const dndBoardList = (
  result: DropResult,
  meetingId: IMeetingSimple['id'],
  boardId: IBoard['id'],
): types.IDndBoardList => ({
  type: constants.DND_BOARD_LIST,
  payload: {
    result,
    meetingId,
    boardId,
  },
});
